import React, { memo } from 'react';
import { Box, PressableIcon } from '@bonanza-social/moonlight';
import {
  useTracker as useCommunityJackpotTracker,
  CommunityJackpotTracker,
} from '@bonanza-social/community-jackpot';
import { StatusHeaderItem } from '@bonanza-social/status';
import { LevelHeaderItem } from '@bonanza-social/levels';

function GameHeader({ onBackPress }: { onBackPress: () => void }) {
  const { visible: communityJackpotTrackerVisible, onMilestoneHit } =
    useCommunityJackpotTracker();

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      gap="space-400"
      paddingHorizontal={{
        mobile: 'space-400',
        tablet: 'space-400',
        desktop: 'space-1000',
      }}
      paddingVertical="space-200"
    >
      <PressableIcon
        width="space-600"
        name="arrowBack"
        gradient="accentBackground"
        onPress={onBackPress}
        testID="back-arrow-button"
      />
      <Box
        flex={1}
        position="relative"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        gap="space-200"
        padding="space-100"
        paddingTop="space-0"
      >
        <Box flex={1} flexDirection="row" gap="space-100">
          {communityJackpotTrackerVisible ? (
            <CommunityJackpotTracker onMilestoneHit={onMilestoneHit} />
          ) : (
            <LevelHeaderItem flex={1} />
          )}
          <StatusHeaderItem flex={3} />
          {/* <QuestsInGameHeaderItem gameId={Number(gameId)} /> */}
        </Box>
      </Box>
    </Box>
  );
}

export default memo(GameHeader);
